import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Neighborhood } from '../Models/Neighborhood';
import { AppBar, createStyles, FormControl, FormControlLabel, IconButton, InputAdornment, List, ListItem, makeStyles, MenuItem, Radio, RadioGroup, Select, Slide, Step, StepLabel, Stepper, TextField, Theme, Toolbar, Typography } from '@material-ui/core';
import { Answer, Question, ScoreInfo } from '../Models/Info';
import { TransitionProps } from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';
import { Address, Landlord, Property } from '../Models/Property';
import { AddPropertyStepIcon, AddPropStepConnector } from './AddPropertyStepIcon';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import TextAreaInputDialog from './TextAreaInputDialog';
import PropertyAddressStep from './PropertyAddressStep';
import PropertyQuestionsStep from './PropertyQuestionsStep';
import LocationStep from './LocationStep';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            position: 'relative',
            backgroundColor: '#0404fc'
        },
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
        stepper: {
            '&.MuiStepIcon-root.MuiStepIcon-completed': {
                color: "red!important"
            }
        },
        input: {
            backgroundColor: "white",
            '& label.Mui-focused': {
                color: '#0404fc',
                borderWidth: "3px"
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: '#0404fc',
                borderWidth: "3px"
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: '#0404fc',
                    borderWidth: "3px"
                },
                '&:hover fieldset': {
                    borderColor: '#0404fc',
                    borderWidth: "3px"
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#0404fc',
                    borderWidth: "3px"
                },
            },
        }
    }),
);





export interface AddPropertyDialogProps {
    property: Property,
    open: boolean,
    onClose: (property: any, propertyScoreInfo: any, neighborhood: any, neighborhoodScoreInfo: any, landlord: any, landlordScoreInfo: any) => void,
    questions: Question[],
    answers: Answer[],
    neighborhoods: Neighborhood[],
    landlords: Landlord[]
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddPropertyDialog(props: AddPropertyDialogProps) {
    const classes = useStyles();
    const steps = ["Address", "Location", "Property Questions", "Neighborhood", "Landlord"]
    const [activeStep, setActiveStep] = React.useState(0);
    const [property, setProperty] = React.useState({} as Property);
    const [address, setAddress] = React.useState<string>("");
    const [addressError, setAddressError] = React.useState<boolean>(false);
    const [city, setCity] = React.useState<string>("");
    const [cityError, setCityError] = useState<boolean>(false);
    const [state, setState] = React.useState<string>("");
    const [stateError, setStateError] = useState<boolean>(false);
    const [zip, setZip] = React.useState<string>("");
    const [zipErorr, setZipError] = useState<boolean>(false);
    const [block, setBlock] = useState<string>("");
    const [blockError, setBlockError] = useState<boolean>(false);
    const [lot, setLot] = useState<string>("");
    const [lotError, setLotError] = useState<boolean>(false);
    const [borough, setBorough] = useState<string>("");
    const [boroughError, setBoroughError] = useState<boolean>(false);
    const [properScoreInfo, setProperScoreInfo] = React.useState<ScoreInfo[]>([] as ScoreInfo[]);
    const [propScoreInfoErrors, setPropScoreInfoErrors] = React.useState<number[]>([] as number[]);
    const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<Neighborhood>({ internalId: 0 } as Neighborhood)
    const [landlord, setLandlord] = React.useState<Landlord>({ internalId: -1 } as Landlord);
    const [landlordName, setLandlordName] = React.useState<string>("");
    const [landlordNameError, setLandlordNameError] = React.useState<boolean>(false);
    const [landlordScoreInfo, setLandlordScoreInfo] = useState<ScoreInfo[]>([] as ScoreInfo[]);
    const [stepErrors, setStepErrors] = useState<string[]>([] as string[]);
    const [masterAddress, setMasterAddress] = useState<string>("");
    const [blockLockError, setBlockLockError] = React.useState<boolean>(false);
    const [openTextAreaInput, setOpenTextAreaInput] = React.useState<boolean>(false);
    const [textAreaValue, setTextAreaValue] = React.useState<string>("");
    const [textAreaIndex, setTextAreaIndex] = React.useState<number>(0);
    const [textAreaInputTitle, setTextAreaInputTitle] = React.useState<string>("");
    const [textAreaInputLabel, setTextAreaInputLabel] = React.useState<string>("");
    
    // Coordinate state
    const [lat, setLat] = React.useState<number | null>(null);
    const [lng, setLng] = React.useState<number | null>(null);
    const [streetLat, setStreetLat] = React.useState<number | null>(null);
    const [streetLng, setStreetLng] = React.useState<number | null>(null);
    const [heading, setHeading] = React.useState<number>(90);



    useEffect(() => {
        if (props.open === true && properScoreInfo.length === 0) {

            if (props.property.id == null) {
                var info = [] as ScoreInfo[]
                props.questions.filter(q => q.questionType === 0 && q.parentQuestionId != null && q.required === true).forEach(q => {

                    var s = {} as ScoreInfo;
                    s.questionDescription = q.description;
                    s.questionId = q.internalId;
                    info.push(s);

                });
                setProperScoreInfo(info);
                info = [] as ScoreInfo[]
                props.questions.filter(q => q.questionType === 2 && q.parentQuestionId != null && q.required === true).forEach(q => {

                    var s = {} as ScoreInfo;
                    s.questionDescription = q.description;
                    s.questionId = q.internalId;
                    info.push(s);

                });
                setLandlordScoreInfo(info);
            }
            else {
                var p = props.property
                setProperty(p);
                info = [] as ScoreInfo[]
                props.questions.filter(q => q.questionType === 0 && q.parentQuestionId != null && q.required === true).forEach(q => {

                    var s = {} as ScoreInfo;

                    s.questionDescription = q.description;
                    s.questionId = q.internalId;
                    s.answerId = p.scoreInfo.find(i => i.questionId === s.questionId)?.answerId as number;
                    s.fact = p.scoreInfo.find(i => i.questionId === s.questionId)?.fact as string
                    s.additionalInfo = p.scoreInfo.find(i => i.questionId === s.questionId)?.additionalInfo as string
                    s.id = p.scoreInfo.find(i => i.questionId === s.questionId)?.id as string;
                    info.push(s);

                });
                setProperScoreInfo(info);
                setAddress(p.addresses[0].address)
                setCity(p.addresses[0].city);
                setState(p.addresses[0].state);
                setZip(p.addresses[0].zip);
                setBorough(p.addresses[0].borough.toString());
                setBlock(p.addresses[0].block.toString());
                setLot(p.addresses[0].lot.toString());
                setMasterAddress(p.addresses[0].masterAddress);
                // Initialize coordinates from existing property
                setLat(p.addresses[0].lat || null);
                setLng(p.addresses[0].lng || null);
                setStreetLat(p.addresses[0].streetLat  || null);
                setStreetLng(p.addresses[0].streetLng  || null);
                setHeading(p.addresses[0].heading || 90);
                setSelectedNeighborhood(props.neighborhoods.filter(n => n.internalId === p.neighborhoodId)[0] as Neighborhood);
                var l = props.landlords.filter(land => land.internalId === p.landlordId)[0];
                setLandlord(l);
                setLandlordName(l.name);
                info = [] as ScoreInfo[]
                props.questions.filter(q => q.questionType === 2 && q.parentQuestionId != null && q.required === true).forEach(q => {

                    var s = {} as ScoreInfo;


                    s.questionDescription = q.description;
                    s.questionId = q.internalId;
                    s.answerId = p.scoreInfo.find(i => i.questionId === s.questionId)?.answerId as number;
                    s.fact = p.scoreInfo.find(i => i.questionId === s.questionId)?.fact as string
                    s.additionalInfo = p.scoreInfo.find(i => i.questionId === s.questionId)?.additionalInfo as string;
                    s.id = p.scoreInfo.find(i => i.questionId === s.questionId)?.id as string;
                    info.push(s);

                });
                setLandlordScoreInfo(info);

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open])
    const handleClose = () => {
        setActiveStep(0);
        props.onClose(null, null, null, null, null, null);
    };

    const handleNext = () => {
        if (activeStep === 0) {
            // Step 0: Address & BBL validation
            setStepErrors([] as string[]);
            if (address === "" || city === "" || state === "" || zip === "") {
                    setAddressError(address === "");
                    if (address === "") {
                        setStepErrors((stepError) => stepError.concat(["Address is Required!"]))
                    }
                    setCityError(city === "")
                    if (city === "") {
                        setStepErrors((stepError) => stepError.concat(["City is Required!"]))
                    }
                    setStateError(state === "")
                    if (state === "") {
                        setStepErrors((stepError) => stepError.concat(["State is Required!"]))
                    }
                    setZipError(zip === "")
                    if (zip === "") {
                        setStepErrors((stepError) => stepError.concat(["Zip is Required!"]))
                    }
            } else {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }
        }
        else if (activeStep === 1) {
            // Step 1: Location validation
            setStepErrors([] as string[]);
            if (borough === "" || block === "" || lot === "") {
                setBoroughError(borough === "");
                if (borough === "") {
                    setStepErrors((stepError) => stepError.concat(["Borough is Required!"]))
                }
                setBlockError(block === "");
                if (block === "") {
                    setStepErrors((stepError) => stepError.concat(["Block is Required!"]))
                }
                setLotError(lot === "");
                if (lot === "") {
                    setStepErrors((stepError) => stepError.concat(["Lot is Required!"]))
                }
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        }
        else if (activeStep === 2) {
            // Step 2: Property Questions validation
            setStepErrors([] as string[]);
            var questionErrors = [] as number[]
            properScoreInfo.forEach((element, i) => {
                if (!element.answerId || element.answerId == null) {
                    questionErrors.push(i)
                }
                if (element.questionId === 3 && !element.additionalInfo) {
                    setBlockLockError(true);
                }
                else if (element.questionId === 3) {
                    setBlockLockError(false);
                }
            });
            if (questionErrors.length > 0) {
                setPropScoreInfoErrors(questionErrors);
                setStepErrors((stepError) => stepError.concat(["Missing Required answer(s)!"]))
            } else {
                setPropScoreInfoErrors([] as number[]);
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        }
        else if (activeStep === 3) {
            // Step 3: Neighborhood validation
            setStepErrors([] as string[]);
            if (selectedNeighborhood.internalId === 0) {
                setStepErrors((stepError) => stepError.concat(["Selecting a neighborhood is Required!"]))
            }
            else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        setStepErrors([] as string[]);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSave = (copy: boolean) => {

        setStepErrors([] as string[]);
        var questionErrors = [] as number[]
        landlordScoreInfo.forEach((element, i) => {
            if (!element.answerId || element.answerId == null) {
                questionErrors.push(i)
            }
        });
        if (landlordName !== "" && questionErrors.length === 0) {
            var p = Object.assign({}, property);
            var l = Object.assign({}, landlord);
            var landlordScore = Object.assign([], landlordScoreInfo) as ScoreInfo[]
            if (p.internalId == null || copy === true) {
                p.internalId = -1;
            }
            if (copy === true) {
                // Clear property ID to ensure backend creates a new property
                p.id = null;
                l.internalId = -1;
                var i = 0;
                while (landlordScore.length > i) {

                    landlordScore[i].id = null
                    i++;
                }
                // When copying, ensure only one address exists and clear its IDs for new creation
                if (p.addresses && p.addresses.length > 0) {
                    // Take only the first address and create a new object to avoid reference issues
                    const firstAddress = Object.assign({}, p.addresses[0]);
                    // Clear IDs so backend creates a new address instead of updating the original
                    firstAddress.internalId = -1;
                    firstAddress.id = null;
                    firstAddress.propertyId = -1;
                    // Replace the addresses array with only this one address
                    p.addresses = [firstAddress];
                    // Debug: Log what we're sending to verify IDs are cleared
                    console.log("COPYING - Address being sent:", {
                        internalId: firstAddress.internalId,
                        id: firstAddress.id,
                        propertyId: firstAddress.propertyId,
                        address: firstAddress.address,
                        city: firstAddress.city,
                        zip: firstAddress.zip
                    });
                }
            }
            console.log(landlordScore);
            setActiveStep(0);
            props.onClose(p, properScoreInfo, selectedNeighborhood, null, l, landlordScore);
        }
        else {
            setLandlordNameError(landlordName === "");
            if (landlordName === "") {
                setStepErrors((stepError) => stepError.concat(["Landlord Name is required or select existing landlord!"]))
            }
            if (questionErrors.length !== 0) {
                setPropScoreInfoErrors(questionErrors);
                setStepErrors((stepError) => stepError.concat(["Missing Required answer(s)!"]))
            }
        }



    };

    const handleChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ address: event.target.value } as Address]
        }
        else {
            p.addresses[0].address = event.target.value;
        }
        setProperty(p)

    };

    const handleChangeMasterAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMasterAddress(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ masterAddress: event.target.value } as Address]
        }
        else {
            p.addresses[0].masterAddress = event.target.value;
        }
        setProperty(p)

    };

    const handleChangeBlock = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBlock(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ block: Number(event.target.value) } as Address]
        }
        else {
            p.addresses[0].block = Number(event.target.value);
        }
        setProperty(p)

    };

    const handleChangeLot = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLot(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ lot: Number(event.target.value) } as Address]
        }
        else {
            p.addresses[0].lot = Number(event.target.value);
        }
        setProperty(p)

    };

    const handleChangeBorough = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBorough(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ lot: Number(event.target.value) } as Address]
        }
        else {
            p.addresses[0].borough = Number(event.target.value);
        }
        setProperty(p)

    };

    const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCity(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ city: event.target.value } as Address]
        }
        else {
            p.addresses[0].city = event.target.value;
        }
        setProperty(p)

    };

    const handleChangeState = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ state: event.target.value } as Address]
        }
        else {
            p.addresses[0].state = event.target.value;
        }
        setProperty(p)

    };

    const handleChangeZip = (event: React.ChangeEvent<HTMLInputElement>) => {
        setZip(event.target.value);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ zip: event.target.value } as Address]
        }
        else {
            p.addresses[0].zip = event.target.value;
        }
        setProperty(p)

    };

    // Coordinate change handlers
    const handleLatChange = (newLat: number | null) => {
        setLat(newLat);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ lat: newLat || 0 } as Address];
        } else {
            p.addresses[0].lat = newLat || 0;
        }
        setProperty(p);
    };

    const handleLngChange = (newLng: number | null) => {
        setLng(newLng);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ lng: newLng || 0 } as Address];
        } else {
            p.addresses[0].lng = newLng || 0;
        }
        setProperty(p);
    };

    const handleStreetLatChange = (newStreetLat: number | null) => {
        setStreetLat(newStreetLat);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ streetLat: newStreetLat || 0 } as Address];
        } else {
            p.addresses[0].streetLat = newStreetLat || 0;
        }
        setProperty(p);
    };

    const handleStreetLngChange = (newStreetLng: number | null) => {
        setStreetLng(newStreetLng);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ streetLng: newStreetLng || 0 } as Address];
        } else {
            p.addresses[0].streetLng = newStreetLng || 0;
        }
        setProperty(p);
    };

    const handleHeadingChange = (newHeading: number) => {
        setHeading(newHeading);
        let p = Object.assign({}, property);
        if (!property.addresses) {
            p.addresses = [{ heading: newHeading } as Address];
        } else {
            p.addresses[0].heading = newHeading;
        }
        setProperty(p);
    };

    const handleChangeAnswer = (event: React.ChangeEvent<{ value: unknown }>, questionIndex: number) => {
        if (activeStep === 2) {
            var temp = Object.assign([], properScoreInfo) as ScoreInfo[];
            temp[questionIndex].answerId = event.target.value as number;
            temp[questionIndex].score = props.answers.find(a => a.internalId === event.target.value as number)?.score as number;
            temp[questionIndex].answerDescription = props.answers.find(a => a.internalId === event.target.value as number)?.description as string;
            setProperScoreInfo(temp);
        }
        else if (activeStep === 4) {
            temp = Object.assign([], landlordScoreInfo) as ScoreInfo[];
            temp[questionIndex].answerId = event.target.value as number;
            temp[questionIndex].score = props.answers.find(a => a.internalId === event.target.value as number)?.score as number;
            temp[questionIndex].answerDescription = props.answers.find(a => a.internalId === event.target.value as number)?.description as string;
            setLandlordScoreInfo(temp);
        }
    }

    const handleChangeFact = (event: React.ChangeEvent<{ value: unknown }>, questionIndex: number) => {
        if (activeStep === 2) {
            var temp = Object.assign([], properScoreInfo) as ScoreInfo[];
            temp[questionIndex].fact = event.target.value as string;
            setProperScoreInfo(temp);
        }
        else if (activeStep === 4) {
            temp = Object.assign([], landlordScoreInfo) as ScoreInfo[];
            temp[questionIndex].fact = event.target.value as string;
            setLandlordScoreInfo(temp);
        }

    };

    const handleChangeAdditionalInfo = (event: React.ChangeEvent<{ value: unknown }>, questionIndex: number) => {
        if (activeStep === 2) {
            var temp = Object.assign([], properScoreInfo) as ScoreInfo[];
            temp[questionIndex].additionalInfo = event.target.value as string;
            setProperScoreInfo(temp);
        }
        else if (activeStep === 4) {
            temp = Object.assign([], landlordScoreInfo) as ScoreInfo[];
            temp[questionIndex].additionalInfo = event.target.value as string;
            setLandlordScoreInfo(temp);
        }

    };

    const handleChangeNeighborhood = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedNeighborhood(props.neighborhoods.find(n => n.internalId.toString() === (event.target as HTMLInputElement).value) as Neighborhood);
    };




    const handleChangeLandlordName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLandlordName(event.target.value);
        let l = Object.assign({}, landlord);
        l.name = event.target.value;
        setLandlord(l)

    };



    const handleCloseTextArea = (value: string, questionIndex: number) => {
        if (activeStep === 2) {
            var temp = Object.assign([], properScoreInfo) as ScoreInfo[];
            temp[questionIndex].fact = value;
            setProperScoreInfo(temp);
        }
        else if (activeStep === 4) {
            temp = Object.assign([], landlordScoreInfo) as ScoreInfo[];
            if(textAreaInputLabel === "Fact")
            {
                temp[questionIndex].fact = value;
            }
            else if(textAreaInputLabel === "Additional Info")
            {
                temp[questionIndex].additionalInfo = value;
            }
            setLandlordScoreInfo(temp);
        }
        setOpenTextAreaInput(false);
        setTextAreaIndex(0);
        setTextAreaValue("")
    }

    return (
        <Dialog TransitionComponent={Transition} fullScreen open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    {property.id == null ? <Typography variant="h6" className={classes.title}>
                        Add Property
                    </Typography> :
                        <Typography variant="h6" className={classes.title}>
                            Edit {property.addresses[0].address}
                        </Typography>
                    }
                    {activeStep > 0 && <Button color="inherit" onClick={handleBack}>Back</Button>}
                    {activeStep === 4 ? (property.id == null ? <Button autoFocus color="inherit" onClick={() => handleSave(false)}>
                        save
                    </Button> :
                        <div>
                            <Button autoFocus color="inherit" onClick={() => handleSave(false)}>
                                save
                            </Button>
                            <Button color="inherit" onClick={() => handleSave(true)}>
                                copy
                            </Button>
                        </div>) : <Button autoFocus color="inherit" onClick={handleNext}>
                        next
                    </Button>}
                </Toolbar>
            </AppBar>
            <DialogContent style={{ padding: "24px" }}>
                <Stepper connector={<AddPropStepConnector />} activeStep={activeStep} style={{ marginBottom: "32px" }}>
                    {steps.map((label) => {
                        return (
                            <Step className={classes.stepper} key={label} >
                                <StepLabel StepIconComponent={AddPropertyStepIcon}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === 0 && <div style={{ padding: "16px 0" }}>
                    {stepErrors.length > 0 && (
                        <div style={{ 
                            margin: "16px 0", 
                            padding: "12px", 
                            backgroundColor: "#ffebee", 
                            border: "1px solid #f44336", 
                            borderRadius: "8px",
                            borderLeft: "4px solid #f44336"
                        }}>
                            <Typography variant="subtitle1" style={{ color: "#d32f2f", marginBottom: "8px", fontWeight: 600 }}>
                                Please fix the following errors:
                            </Typography>
                            <div style={{ 
                                display: "grid", 
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
                                gap: "4px 16px",
                                alignItems: "start"
                            }}>
                                {stepErrors.map((e, i) => (
                                    <div key={i} style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        color: "#d32f2f",
                                        fontSize: "13px",
                                        lineHeight: "1.2"
                                    }}>
                                        <span style={{ 
                                            marginRight: "6px", 
                                            fontSize: "14px", 
                                            fontWeight: "bold",
                                            flexShrink: 0
                                        }}>•</span>
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <PropertyAddressStep
                        address={address}
                        addressError={addressError}
                        city={city}
                        cityError={cityError}
                        state={state}
                        stateError={stateError}
                        zip={zip}
                        zipError={zipErorr}
                        masterAddress={masterAddress}
                        onAddressChange={handleChangeAddress}
                        onCityChange={handleChangeCity}
                        onStateChange={handleChangeState}
                        onZipChange={handleChangeZip}
                        onMasterAddressChange={handleChangeMasterAddress}
                    />
                </div>}
                {activeStep === 1 && <div style={{ padding: "16px 0" }}>
                    {stepErrors.length > 0 && (
                        <div style={{ 
                            margin: "16px 0", 
                            padding: "12px", 
                            backgroundColor: "#ffebee", 
                            border: "1px solid #f44336", 
                            borderRadius: "8px",
                            borderLeft: "4px solid #f44336"
                        }}>
                            <Typography variant="subtitle1" style={{ color: "#d32f2f", marginBottom: "8px", fontWeight: 600 }}>
                                Please fix the following errors:
                            </Typography>
                            <div style={{ 
                                display: "grid", 
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
                                gap: "4px 16px",
                                alignItems: "start"
                            }}>
                                {stepErrors.map((e, i) => (
                                    <div key={i} style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        color: "#d32f2f",
                                        fontSize: "13px",
                                        lineHeight: "1.2"
                                    }}>
                                        <span style={{ 
                                            marginRight: "6px", 
                                            fontSize: "14px", 
                                            fontWeight: "bold",
                                            flexShrink: 0
                                        }}>•</span>
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <LocationStep
                        address={address}
                        city={city}
                        state={state}
                        zip={zip}
                        onBoroughChange={handleChangeBorough}
                        onBlockChange={handleChangeBlock}
                        onLotChange={handleChangeLot}
                        currentBorough={borough}
                        currentBlock={block}
                        currentLot={lot}
                        boroughError={boroughError}
                        blockError={blockError}
                        lotError={lotError}
                        existingLat={lat}
                        existingLng={lng}
                        existingStreetLat={streetLat}
                        existingStreetLng={streetLng}
                        existingHeading={heading}
                        onLatChange={handleLatChange}
                        onLngChange={handleLngChange}
                        onStreetLatChange={handleStreetLatChange}
                        onStreetLngChange={handleStreetLngChange}
                        onHeadingChange={handleHeadingChange}
                    />
                </div>}
                {activeStep === 2 && <div style={{ padding: "16px 0" }}>
                    {stepErrors.length > 0 && (
                        <div style={{ 
                            margin: "16px 0", 
                            padding: "12px", 
                            backgroundColor: "#ffebee", 
                            border: "1px solid #f44336", 
                            borderRadius: "8px",
                            borderLeft: "4px solid #f44336"
                        }}>
                            <Typography variant="subtitle1" style={{ color: "#d32f2f", marginBottom: "8px", fontWeight: 600 }}>
                                Please fix the following errors:
                            </Typography>
                            <div style={{ 
                                display: "grid", 
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
                                gap: "4px 16px",
                                alignItems: "start"
                            }}>
                                {stepErrors.map((e, i) => (
                                    <div key={i} style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        color: "#d32f2f",
                                        fontSize: "13px",
                                        lineHeight: "1.2"
                                    }}>
                                        <span style={{ 
                                            marginRight: "6px", 
                                            fontSize: "14px", 
                                            fontWeight: "bold",
                                            flexShrink: 0
                                        }}>•</span>
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <PropertyQuestionsStep
                        properScoreInfo={properScoreInfo}
                        propScoreInfoErrors={propScoreInfoErrors}
                        blockLockError={blockLockError}
                        questions={props.questions}
                        answers={props.answers}
                        onAnswerChange={handleChangeAnswer}
                        onFactChange={handleChangeFact}
                        onAdditionalInfoChange={handleChangeAdditionalInfo}
                        address={address}
                    />
                </div>}
                {activeStep === 3 && <div style={{ padding: "16px 0" }}>
                    {stepErrors.length > 0 && (
                        <div style={{ 
                            margin: "16px 0", 
                            padding: "12px", 
                            backgroundColor: "#ffebee", 
                            border: "1px solid #f44336", 
                            borderRadius: "8px",
                            borderLeft: "4px solid #f44336"
                        }}>
                            <Typography variant="subtitle1" style={{ color: "#d32f2f", marginBottom: "8px", fontWeight: 600 }}>
                                Please fix the following errors:
                            </Typography>
                            <div style={{ 
                                display: "grid", 
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
                                gap: "4px 16px",
                                alignItems: "start"
                            }}>
                                {stepErrors.map((e, i) => (
                                    <div key={i} style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        color: "#d32f2f",
                                        fontSize: "13px",
                                        lineHeight: "1.2"
                                    }}>
                                        <span style={{ 
                                            marginRight: "6px", 
                                            fontSize: "14px", 
                                            fontWeight: "bold",
                                            flexShrink: 0
                                        }}>•</span>
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <Typography variant="h5">Select Existing Neighborhood: {selectedNeighborhood.name !== null && <strong>{selectedNeighborhood.name}</strong>}</Typography>
                    <FormControl component="fieldset">
                        <RadioGroup aria-label="neighborhood" name="neighborhood" value={selectedNeighborhood.internalId} onChange={handleChangeNeighborhood}>
                            {props.neighborhoods.map((n, i) => {
                                return (
                                    <FormControlLabel key={i} value={n.internalId} control={<Radio />} label={n.name} />
                                )
                            })}
                        </RadioGroup>
                    </FormControl>
                </div>}
                {activeStep === 4 && <div style={{ padding: "16px 0" }}>
                    {stepErrors.length > 0 && (
                        <div style={{ 
                            margin: "16px 0", 
                            padding: "12px", 
                            backgroundColor: "#ffebee", 
                            border: "1px solid #f44336", 
                            borderRadius: "8px",
                            borderLeft: "4px solid #f44336"
                        }}>
                            <Typography variant="subtitle1" style={{ color: "#d32f2f", marginBottom: "8px", fontWeight: 600 }}>
                                Please fix the following errors:
                            </Typography>
                            <div style={{ 
                                display: "grid", 
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
                                gap: "4px 16px",
                                alignItems: "start"
                            }}>
                                {stepErrors.map((e, i) => (
                                    <div key={i} style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        color: "#d32f2f",
                                        fontSize: "13px",
                                        lineHeight: "1.2"
                                    }}>
                                        <span style={{ 
                                            marginRight: "6px", 
                                            fontSize: "14px", 
                                            fontWeight: "bold",
                                            flexShrink: 0
                                        }}>•</span>
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div>
                        <Typography variant="h5">Create new Landlord:</Typography>
                        <div>
                            <TextField error={landlordNameError} helperText={landlordNameError ? "**Required" : ""}
                                style={{ width: "75%", marginLeft: "12.5%" }} onChange={handleChangeLandlordName} value={landlordName} id="landlord" label="Landlord Name" />
                        </div>
                        <div>
                            <List>
                                {landlordScoreInfo.map((q, i) => {
                                    return (
                                        <ListItem style={{ display: "flex", marginTop: "10px" }} key={i}>
                                            <div style={{ width: "33%" }}>
                                                <Typography variant="body1">{q.questionDescription}</Typography>
                                            </div>
                                            <div style={{ width: "30%", marginLeft: "3%", marginTop: "11px" }}>
                                                <FormControl style={{ width: "100%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={q.answerId == null ? '' : q.answerId}
                                                        onChange={(e) => {
                                                            handleChangeAnswer(e, i)
                                                        }}
                                                    >
                                                        {props.answers.map((a, j) => {
                                                            if (a.questionId === q.questionId) {
                                                                return (
                                                                    <MenuItem key={j} value={a.internalId}>{a.description} ({a.score})</MenuItem>
                                                                )
                                                            }
                                                            else {
                                                                return null;
                                                            }
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ width: "14%", display: "flex", marginLeft: "2%" }}>
                                                <TextField label="Fact" style={{ width: "100%" }} size="small" onChange={(e) => {
                                                    handleChangeFact(e, i)
                                                }} value={q.fact != null ? q.fact : ""}
                                                    InputProps={{
                                                        endAdornment: q.questionId === 75 ? <InputAdornment position="end"><IconButton
                                                            onClick={() => {
                                                                setTextAreaInputTitle(q.questionDescription)
                                                                setTextAreaIndex(i)
                                                                setTextAreaValue(q.fact != null ? q.fact : "")
                                                                setOpenTextAreaInput(true)
                                                                setTextAreaInputLabel("Fact")
                                                            }}><OpenInNewIcon /></IconButton></InputAdornment> : null,
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: "15%", display: "flex", marginLeft: "2%" }}>
                                                <TextField label="Additional Info" style={{ width: "100%" }} size="small"
                                                    InputProps={{
                                                        endAdornment: q.questionId === 70 || q.questionId === 71 ? <InputAdornment position="end"><IconButton
                                                            onClick={() => {
                                                                setTextAreaInputTitle(q.questionDescription)
                                                                setTextAreaIndex(i)
                                                                setTextAreaValue(q.additionalInfo != null ? q.additionalInfo : "")
                                                                setOpenTextAreaInput(true)
                                                                setTextAreaInputLabel("Additional Info")
                                                            }}><OpenInNewIcon /></IconButton></InputAdornment> : null,
                                                    }}
                                                    onChange={(e) => {
                                                        handleChangeAdditionalInfo(e, i)
                                                    }} value={q.additionalInfo != null ? q.additionalInfo : ""}
                                                />
                                            </div>
                                        </ListItem>
                                    )
                                })}
                            </List>
                        </div>
                    </div>
                </div>}
            </DialogContent>
            <TextAreaInputDialog label={textAreaInputLabel} title={textAreaInputTitle} index={textAreaIndex} value={textAreaValue} handleClose={handleCloseTextArea} open={openTextAreaInput} />
        </Dialog>
    );
}
